import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import foydalanilgan from '../Components/fayl/Foydalanilgan.pdf'


export const Foydalanilgan = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    return (
        <div className="card" >
            <Button className='button' onClick={showModal}>
                <a href={foydalanilgan}>Foydalanilgan adabiyotlar</a>
                
            </Button>

        </div>
    )
}
